import { useEffect, useState } from "react";
import { useApi } from "../../api";
import { PageHeader } from "../GenericPage";
import { Notice } from "../../lib/ui";

/* My profile – port of profile.php (API: /api/profile, /api/profile/password). Password: at least 6 characters. */

export default function Profile() {
  const api = useApi();
  const [p, setP] = useState(null);
  const [error, setError] = useState(null);
  const [pw, setPw] = useState({ current_password: "", new_password: "", confirm_password: "" });
  const [notice, setNotice] = useState(null);
  useEffect(() => { api.get("/api/profile").then(setP).catch((e) => setError(e.message)); }, [api]);
  const change = async (e) => {
    e.preventDefault();
    try { const r = await api.post("/api/profile/password", pw); setNotice({ tone: r.success ? "ok" : "err", text: r.message }); if (r.success) setPw({ current_password: "", new_password: "", confirm_password: "" }); }
    catch (err) { setNotice({ tone: "err", text: err.message }); }
  };
  const initials = (p?.client_name || "?").split(" ").slice(0, 2).map((x) => x[0]).join("").toUpperCase();
  return (
    <main className="pg" style={{ maxWidth: "60rem" }}>
      <PageHeader slug="profile" />
      <Notice notice={error && { tone: "err", text: error }} />
      {p && (
        <div className="grid2" style={{ gridTemplateColumns: "minmax(0,2fr) minmax(0,3fr)" }}>
          <section className="panel card-pad" style={{ textAlign: "center" }}>
            <span className="avatar" style={{ width: "4.5rem", height: "4.5rem", fontSize: "1.5rem", borderRadius: "1rem" }}>{initials}</span>
            <h2 style={{ fontSize: "1.15rem", margin: ".7rem 0 .1rem" }}>{p.client_name}</h2>
            <p style={{ margin: 0, color: "var(--muted)" }}>@{p.username}</p>
            {p.role && <span className="pill-tag brand" style={{ marginTop: ".5rem" }}>{p.role}</span>}
            <dl style={{ textAlign: "left", marginTop: "1.2rem", display: "grid", gap: ".6rem", fontSize: ".875rem" }}>
              <div><dt style={{ color: "var(--muted)", fontSize: ".75rem" }}>Email</dt><dd style={{ margin: 0 }}>{p.contact_email || "–"}</dd></div>
              <div><dt style={{ color: "var(--muted)", fontSize: ".75rem" }}>Phone</dt><dd style={{ margin: 0 }}>{p.contact_phone || "–"}</dd></div>
              <div><dt style={{ color: "var(--muted)", fontSize: ".75rem" }}>Address</dt><dd style={{ margin: 0 }}>{p.address || "–"}</dd></div>
              <div><dt style={{ color: "var(--muted)", fontSize: ".75rem" }}>Staff / client number</dt><dd style={{ margin: 0 }} className="mono">{p.personal_number}</dd></div>
            </dl>
          </section>
          <section className="panel">
            <form className="form" onSubmit={change} style={{ gridTemplateColumns: "1fr", maxWidth: "none" }}>
              <h2 style={{ fontSize: "1rem", margin: 0 }}>Change password</h2>
              <Notice notice={notice} onClose={() => setNotice(null)} />
              {[["current_password", "Current password", "current-password"], ["new_password", "New password", "new-password"], ["confirm_password", "Confirm new password", "new-password"]].map(([k, l, ac]) => (
                <div className="field" key={k}><label htmlFor={`pf-${k}`}>{l}</label><input id={`pf-${k}`} type="password" required autoComplete={ac} minLength={k === "current_password" ? undefined : 6}
                  value={pw[k]} onChange={(e) => setPw({ ...pw, [k]: e.target.value })} /></div>))}
              <div className="form-actions"><button type="submit" className="btn primary"><i className="fas fa-key" /> Update password</button></div>
            </form>
          </section>
        </div>
      )}
    </main>
  );
}
